import {toast} from 'sonner'
import {useCallback} from 'react'

interface ToastOptions {
    title: string
    status?: 'success' | 'error' | 'info' | 'warning'
    action?: React.ReactNode
    position?: string
    duration?: number
    variant?: string
    isClosable?: boolean
}

/**
 * Drop-in replacement for Chakra's useToast — delegates to Sonner.
 * Keeps the same {title, status} call signature so consumers don't change.
 */
export function useToast() {
    return useCallback(({title, status = 'info', duration = 5000}: ToastOptions) => {
        const opts = {
            duration,
            style: {
                background:
                    status === 'success'
                        ? '#38A169'
                        : status === 'error'
                        ? '#E53E3E'
                        : status === 'warning'
                        ? '#DD6B20'
                        : '#3182CE',
                color: '#fff',
                borderRadius: '0.375rem',
                fontSize: '0.875rem'
            }
        }
        switch (status) {
            case 'success':
                return toast.success(title, opts)
            case 'error':
                return toast.error(title, opts)
            case 'warning':
                return toast.warning(title, opts)
            default:
                return toast.info(title, opts)
        }
    }, [])
}
